import React, { useCallback, useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import CustomDonutChart from '../../../components/charts/CustomDonutChart';
import { IOrderDetailed } from '../../../types/orders';
import { useStyles } from './styles';

interface IReasons {
  interval: number;
  anotherPlaceRequest: number;
  eletricCableLoading: number;
  shiftEnded: number;
}

interface IncompleteOrdersContentMobile {
  orders: IOrderDetailed[];
}

const IncompleteOrdersContentMobile: React.FC<IncompleteOrdersContentMobile> = ({
  orders,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [countIncompleteOrders, setCountIncompleteOrders] = useState<IReasons>({
    interval: 0,
    anotherPlaceRequest: 0,
    eletricCableLoading: 0,
    shiftEnded: 0,
  });

  const handleCountIncompleteOrders = useCallback(() => {
    const totalIncompleteOrders = orders.filter(
      order => order.status === 'INCOMPLETA',
    ).length;

    const percentInterval =
      orders.filter(order => order.reason?.toLowerCase() === 'intervalo')
        .length / totalIncompleteOrders;

    const percentAnotherPlaceRequest =
      orders.filter(
        order =>
          order.reason?.toLowerCase() === 'demanda urgente em outro local',
      ).length / totalIncompleteOrders;

    const percentEletricCableLoading =
      orders.filter(
        order =>
          order.reason?.toLowerCase() === 'carregamento de cabo elétrico',
      ).length / totalIncompleteOrders;

    const percentShiftEnded =
      orders.filter(order => order.reason?.toLowerCase() === 'final do turno')
        .length / totalIncompleteOrders;

    setCountIncompleteOrders({
      interval: percentInterval
        ? Number((percentInterval * 100).toFixed(0))
        : 0,
      anotherPlaceRequest: percentAnotherPlaceRequest
        ? Number((percentAnotherPlaceRequest * 100).toFixed(0))
        : 0,
      eletricCableLoading: percentEletricCableLoading
        ? Number((percentEletricCableLoading * 100).toFixed(0))
        : 0,
      shiftEnded: percentShiftEnded
        ? Number((percentShiftEnded * 100).toFixed(0))
        : 0,
    });
  }, [orders]);

  useEffect(() => {
    if (orders.length > 0) {
      handleCountIncompleteOrders();
    }
  }, [orders, handleCountIncompleteOrders]);

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography className={classes.title} variant="h3">
          {t('screens:orders.reasonForOrderNotFinished')}
        </Typography>
      </div>

      <div className={classes.mobileCharts}>
        <CustomDonutChart
          values={[countIncompleteOrders.anotherPlaceRequest]}
          color={theme.palette.primary.main}
          unit="%"
        >
          <div className={classes.individualChartContainer}>
            <Typography className={classes.subtitle} variant="subtitle2">
              {t('screens:orders.urgentDemandElsewhere')}
            </Typography>
          </div>
        </CustomDonutChart>

        <CustomDonutChart
          values={[countIncompleteOrders.eletricCableLoading]}
          color={theme.palette.primary.light}
          unit="%"
        >
          <div className={classes.individualChartContainer}>
            <Typography className={classes.subtitle} variant="subtitle2">
              {t('screens:orders.electricCableCharging')}
            </Typography>
          </div>
        </CustomDonutChart>
        <CustomDonutChart
          values={[countIncompleteOrders.interval]}
          color={theme.palette.secondary.main}
          unit="%"
        >
          <div className={classes.individualChartContainer}>
            <Typography className={classes.subtitle} variant="subtitle2">
              {t('screens:orders.interval')}
            </Typography>
          </div>
        </CustomDonutChart>
        <CustomDonutChart
          values={[countIncompleteOrders.shiftEnded]}
          color={theme.palette.secondary.light}
          unit="%"
          margin={56}
        >
          <div className={classes.mobileIndividualChartContainer}>
            <Typography className={classes.subtitle} variant="subtitle2">
              {t('screens:orders.shiftEnd')}
            </Typography>
          </div>
        </CustomDonutChart>
      </div>
    </>
  );
};

export default IncompleteOrdersContentMobile;
